/** See `src/i18n/locales/en/manageSupport.ts`. */
export const manageSupport = {
  page: {
    title: 'Support',
    lead: 'Tous les tickets de support de la plateforme, filtrables par statut et priorité.',
    filterStatus: 'Statut',
    filterPriority: 'Priorité',
    allStatuses: 'Tous les statuts',
    allPriorities: 'Toutes les priorités',
    empty: 'Aucun ticket ne correspond à ces filtres.',
    rowsLabel: 'les tickets',
    subject: 'Sujet',
    company: 'Entreprise',
    status: 'Statut',
    priority: 'Priorité',
    createdAt: 'Ouvert',
  },
  status: {
    open: 'Ouvert',
    in_progress: 'En cours',
    resolved: 'Résolu',
    closed: 'Fermé',
  },
  priority: {
    low: 'Basse',
    normal: 'Normale',
    high: 'Haute',
    urgent: 'Urgente',
  },
  detail: {
    thisTicket: 'ce ticket',
    requesterTitle: 'Demandeur',
    requesterLabel: 'le demandeur',
    controlsTitle: 'Statut et priorité',
    save: 'Enregistrer',
    threadTitle: 'Conversation',
    threadEmpty: 'Aucun message pour le moment.',
    replyLabel: 'Réponse',
    reply: 'Envoyer la réponse',
  },
} as const;
